import {
  callAPI,
  getEquipmentURL,
  getFarmDetailsServiceUrl,
  getNewlyAddedEquipmentUrl,
  myFinancialAssetInfoCall,
  getExpenseDetailsServiceUrl,
} from './sagaHelper';

import {call} from 'redux-saga/effects';

export function* loadCropsDetails(customerId) {
  const loadCrops = yield call(callAPI, {
    method: 'get',
    url: getFarmDetailsServiceUrl(customerId),
  });
  return loadCrops;
}

export function* loadExpenseDetails(customerId, cropId) {
  const loadExpenses = yield call(callAPI, {
    method: 'get',
    url: getExpenseDetailsServiceUrl(customerId, cropId),
  });

  return loadExpenses;
}

export function* loadNewlyAddedEquipmentDetails(customerId) {
  const loadEquipments = yield call(callAPI, {
    method: 'get',
    url: getNewlyAddedEquipmentUrl(customerId),
  });
  return loadEquipments;
}

export function* loadExistingEquipment(customerId, selectedAccountNumber) {
  const existingEquipment = yield call(myFinancialAssetInfoCall, {
    customerId,
    selectedAccountNumber,
  });
  return existingEquipment;
}

export function* updateCropsDetailsCall(customerId, payload) {
  const loadCrops = yield call(callAPI, {
    method: 'put',
    url: getFarmDetailsServiceUrl(customerId),
    data: payload,
  });
  return loadCrops;
}

export function* createCropsDetailsCall(customerId, payload) {
  const loadCrops = yield call(callAPI, {
    method: 'post',
    url: getFarmDetailsServiceUrl(customerId),
    data: payload,
  });
  return loadCrops;
}

export function* createEquipmentDetailsCall(customerId, payload) {
  const response = yield call(callAPI, {
    method: 'post',
    url: getEquipmentURL(customerId),
    data: payload,
  });

  return response;
}

export function* updateEquipmentDetails(customerId, payload) {
  const response = yield call(callAPI, {
    method: 'patch',
    url: getEquipmentURL(customerId),
    data: payload,
  });

  return response;
}
export function* updateYieldDetails(customerId, payload) {
  const response = yield call(callAPI, {
    method: 'put',
    url: getFarmDetailsServiceUrl(customerId),
    data: payload,
  });

  return response;
}

export function* getYieldDetails(customerId) {
  const response = yield call(callAPI, {
    method: 'get',
    url: getFarmDetailsServiceUrl(customerId),
  });

  return response;
}

export function* addIncomeDetails(customerId, payload) {
  const response = yield call(callAPI, {
    method: 'post',
    url: getExpenseDetailsServiceUrl(
      customerId,
      payload.cropId,
      payload.entryType
    ),
    data: payload,
  });

  return response;
}

export function* updateIncomeDetails(customerId, payload) {
  const response = yield call(callAPI, {
    method: 'patch',
    url: getExpenseDetailsServiceUrl(
      customerId,
      payload.data[0].cropId,
      payload.data[0].entryType
    ),
    data: payload,
  });

  return response;
}

export function* getIncomeDetails(customerId, cropId, entryType) {
  const loadExpenses = yield call(callAPI, {
    method: 'get',
    url: getExpenseDetailsServiceUrl(customerId, cropId, entryType),
  });

  return loadExpenses;
}
